import * as React from "react";
const IconFacebookLine = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M35.9 62.3h-7.3c-2.2 0-4-1.9-4-4.2V36.6h-5.3c-2.2 0-4-1.9-4-4.2V26c0-2.3 1.8-4.2 4-4.2h5.2v-5.3c0-8.7 5.4-14.8 13.2-14.8h5.5c2.2 0 4 1.9 4 4.2v7.5c0 2.3-1.8 4.2-4 4.2h-3.4v4.1h4.8c1.2.1 2.3.6 3.1 1.5.8 1 1.1 2.2.9 3.5L47.4 33c-.3 2-1.9 3.4-3.9 3.4h-3.7V58c0 2.4-1.7 4.3-3.9 4.3m-6.8-4.5h6.2V34.2c0-1.2 1-2.3 2.3-2.3H43l1.1-5.7h-6.5c-1.2 0-2.3-1-2.3-2.3v-6.7c0-1.9.5-4.2 4.1-4.2h3.3V6.3h-5c-5.3 0-8.7 4-8.7 10.3v7.5c0 1.2-1 2.3-2.3 2.3h-6.9v5.7h7c1.2 0 2.3 1 2.3 2.3zm15-31.9" />
  </svg>
);
export default IconFacebookLine;
